import React from "react";

export function PowProgress({ visible, value, label = "Проверяем браузер…" }) {
  if (!visible) {
    return null;
  }
  const percent = Math.max(0, Math.min(100, Math.round(value || 0)));
  return (
    <div className="af-pow" role="status" aria-live="polite">
      <div className="af-pow-label">{label}</div>
      <div className="af-pow-bar">
        <div className="af-pow-fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}
